<section class="main-section form-section">
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-md-6">
              <label style="font-size:11px" class="control-label">Reason For Return</label>
              <div class="form-group">
                <select class="form-control" id="reason" [(ngModel)]="reason"  [ngModelOptions]="{standalone: true}" required>
                  <option *ngFor="let r of reasonList" [ngValue]="r.config">{{r.config}}</option>
                </select>
              </div>
              <div id="statusText1" class="invalid-feedback d-block ml-3 shift-invalid-text" [hidden]="!statusText1">{{statusText1}}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label class="text-black mb-2"><b>Customer :</b><span class="ml-1">{{headerDetails.accountOwnerCustomerName}}</span></label>
            </div>
            <div class="col-md-4">
              <label class="text-black mb-2"><b>Warehouse :</b><span class="ml-1">{{headerDetails.sourceWarehouseName}}</span></label>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <label class="text-black mb-2"><b>Order Number :</b><span class="ml-1">{{headerDetails.orderNumber}}</span></label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Product List</h2>
          <div class="row mt-3">
            <div class="col-lg-10 col-md-12">
              <table class="table table-stripe">
                <thead>
                <tr>
                  <th>SKU</th>
                  <th>Product Name</th>
                  <th>Ordered Quantity</th>
                  <th>Returned Quantity</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let h of oderLines">
                  <td class="text-black mb-3">{{h.sku}}</td>
                  <td>{{h.productName}}</td>
                  <td>{{h.quantity}}</td>
                  <td><input type="text" class="form-control" (blur)="typeReturnedQuantity()" [ngClass]="{'is-invalid':statusText2}" required [(ngModel)]="h.returnQuantity" [ngModelOptions]="{standalone: true}"></td>
                </tr>
                </tbody>
              </table>
              <div id="statusText2" class="invalid-feedback d-block ml-3 shift-invalid-text" [hidden]="!statusText2">{{statusText2}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
  <div class="col-12 text-right">
    <button type="reset" routerLink="/admin/returns" class="btn btn-cancel">Cancel</button>
    <button type="submit" (click)="submitReturn()"  class="btn btn-orange ml-3">Return</button>
  </div>
</div>
</div>
